import { PageMetaDefault } from '../../../constants';

export const staticMetaProps = () => ({
  seoUrl: PageMetaDefault.canonicalUrl,
  seoTitle: PageMetaDefault.metaTitle,
  seoDescription: PageMetaDefault.metaDescription,
  seoKeywords: PageMetaDefault.metaKeywords,
});
